var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSlicedShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 272,
    height: 311,
    viewBox: "0 0 272 311",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.8187 155.324C33.7209 145.122 30.6825 134.016 29.877 122.64C29.0714 111.264 30.5144 99.8401 34.1237 89.0216C37.7329 78.2031 43.4377 68.2014 50.9122 59.5875C58.3868 50.9737 67.4848 43.9165 77.6868 38.8187C87.8887 33.721 98.9949 30.6826 110.371 29.8771C121.747 29.0715 133.171 30.5145 143.989 34.1237C154.808 37.733 164.81 43.4377 173.423 50.9123C182.037 58.3869 189.094 67.4849 194.192 77.6868L116.505 116.505L38.8187 155.324Z",
    fill: "url(#paint0_linear_10_424)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6878 233.062C72.5901 222.86 69.5517 211.754 68.7461 200.378C67.9406 189.002 69.3836 177.578 72.9928 166.76C76.6021 155.941 82.3068 145.94 89.7814 137.326C97.256 128.712 106.354 121.655 116.556 116.557C126.758 111.459 137.864 108.421 149.24 107.615C160.616 106.81 172.04 108.253 182.858 111.862C193.677 115.471 203.679 121.176 212.292 128.651C220.906 136.125 227.964 145.223 233.061 155.425L155.375 194.244L77.6878 233.062Z",
    fill: "url(#paint1_linear_10_424)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10_424",
    x1: 155.324,
    y1: 194.192,
    x2: 77.6868,
    y2: 38.8187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.245,
    stopColor: "#FF6A87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F23F62"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10_424",
    x1: 194.193,
    y1: 271.93,
    x2: 116.556,
    y2: 116.557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#FF6A87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F23F62"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlicedShape);
export default __webpack_public_path__ + "static/media/sliced-shape.0219fe21e0be6cef2a069f4f8a44970b.svg";
export { ForwardRef as ReactComponent };